/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useMemo } from 'react';
import { Notification, updateNotification } from '../../../../store/Notifications';
import { TextBlock } from '../../../Atoms/Text';
import { Comment } from '../../../../store/Comment';
import { sanitizeCommentHtml } from '../../DetailsComments/commentHtml';
import { htmlTextPreview } from '../../../../utils/htmlPreview';

/** A comment notification's body: who wrote, what they did, as `verb` says, and the comment's text on one line. */
export const CommentNotificationBody = ({ notification, verb }: { notification: Notification; verb: string }) => {
  const message = notification.notification_message;
  const entity = message.content.entity as Comment;
  const preview = useMemo(() => htmlTextPreview(sanitizeCommentHtml(entity.comment_text), 250), [entity.comment_text]);

  return (
    <div
      className="space-y-1 hover:cursor-pointer ml-9"
      onClick={() =>
        updateNotification({
          ...notification,
          is_read: true
        })
      }>
      <TextBlock
        size="sm14"
        weight="bold">
        @{entity.portal_user_name} {verb}
      </TextBlock>
      <TextBlock
        size="sm"
        weight="normal">
        {preview}
      </TextBlock>
    </div>
  );
};
